import { Axios } from 'cms-api'
import { initializeApollo } from 'utils/apolloClient'
import { addError } from 'utils/rum'

export const prepareNavigationProps = async () => {
  try {
    // ToDo: Make sure that PublicLayout query is in sync
    const publicLayout = await Axios.client().getPublicLayout({
      populate: {
        widgets: {
          on: {
            'widgets.feature-bar-widget': {
              populate: '*',
            },
            'widgets.public-layout-menu-widget': {
              populate: '*',
            },
          },
        },
      } as never,
    })

    const shopNavigation =
      await Axios.client().getNavigationRenderIdOrSlug('shop-navigation')

    return {
      shopNavigation,
      publicLayout,
    }
  } catch (error) {
    addError(error)
    return []
  }
}

export const prepareGetStaticNavigationProps = async () => {
  try {
    const apolloClient = initializeApollo()
    const navigation = await prepareNavigationProps()

    return {
      props: {
        navigation,
        // TODO fix initialApolloState after getDataFromTree implementation #1545
        initialApolloState: apolloClient.cache.extract(),
      },
      revalidate: 24 * 3600,
    }
  } catch (error) {
    addError(error)
    return {
      notFound: true,
      props: { navigation: [] },
      revalidate: 24 * 3600,
    }
  }
}
